export default "__VITE_ASSET__DPS6eajJ__"